export default {
    emailAlertBiz: {
        common: {
            emailAutoComplete: {
                sendToTip: 'メールアドレスを入力し、複数ある場合、Enterキーで区切ってください。',
                addEmail: 'メール：',
                single: '個人',
                team: 'チーム',
                teamManage: '私のチームを管理',
                teamCount: 'メンバー{count}名',
                noMatchedTeam: '該当するチームはありません',
                noMatchedSingle: '相関するメールアドレスが一致しませんでした',
                includeExternal: '外来者を含む',
            },
            alertFrequency: {
                weekly: '毎週',
                monthly: '毎月',
                everyday: '毎日',
                weekdays: [
                    null,
                    '月曜日',
                    '火曜日',
                    '水曜日',
                    '木曜日',
                    '金曜日',
                    '土曜日',
                    '日曜日',
                ],
                date: '{n}日',
                lastDay: '最終日',
            },
            alertDialog: {
                createTitle: 'アラート',
                cancel: 'キャンセル',
                submit: '確定',
            },
            commonModule: {
                sendTo: '宛先',
                self: '自分',
                frequency: '通知頻度',
                alertNoUpdate: '更新がなくても通知を受け取る',
                errorEmail: 'メールアドレスの形式が正しくありません',
                emailToOtherTips: '入力したメールユーザーの同意を得たことを確認するにはこのボックスをチェックしてください。',
            },
        },
        discovery: {

        },
        chemical: {

        },
    },
};
